import React, { useEffect, useState } from 'react'
import { formatDistance } from 'date-fns'
import { ChartBarIcon, ClockIcon, ShieldCheckIcon } from '@heroicons/react/solid'
import Link from '@/components/Link'
import { convertAmount } from '../utils/currencyResolver'
import { useFirestore } from 'react-redux-firebase'
import { getOrdinal } from '@/utils/getOrdinal'

export default function RaceTable({ data }) {
  const [leadersData, setLeadersData] = useState([])

  useEffect(() => {
    if (data && data.leaders) {
      let leaders = []
      for (const [key, value] of Object.entries(data.leaders)) {
        leaders.push({ id: key, value })
      }
      setLeadersData(leaders)
    }
  }, [data])

  if (!data) {
    return (
      <div className="py-8 text-center text-gray-300">No active races.</div>
    )
  }

  const endDate = formatDistance(
    new Date(data.endDate.seconds * 1000),
    new Date(),
    { addSuffix: true }
  )

  return (
    <div>
      <div className="flex justify-between pb-3 border-b border-gray-800">
        <Link to={`?modal=race&raceId=${data.id}`}>
          <span className="flex items-center font-medium group">
            <ClockIcon className="mr-1 w-4 text-gray-300 group-hover:text-gray-300 transition duration-300" />
            {data.title}
          </span>
        </Link>
        <span className="flex items-center font-medium group">
          <ChartBarIcon className="mr-1 w-4 text-gray-300 group-hover:text-gray-300 transition duration-300" />
          Ends {endDate}
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-gray-300">
          <thead className="mb-4">
            <tr>
              <th className="w-24 p-4 text-sm font-medium text-left whitespace-nowrap">User</th>
              <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Wagered</th>
              <th className="w-24 p-4 text-sm font-medium text-right whitespace-nowrap">Prize</th>
            </tr>
          </thead>
          <tbody>
            {leadersData.sort((a, b) => a.value > b.value ? -1 : 1).map((item, index) => <TableRow item={item} key={item.id} index={index} prizes={data.prizes} />)}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const TableRow = ({ item, index, prizes }) => {
  const firestore = useFirestore()
  const [userData, setUserData] = useState(null)

  useEffect(() => {
    const setData = async () => {
      const userRef = await firestore.collection("users").doc(item.id).get()
      const userData = userRef.data()
      setUserData({
        id: item.id,
        privacy: { ...userData?.privacy },
        username: userData?.privacy?.race ? 'Hidden' : userData?.username
      })
    }
    setData()
  }, [item])

  return (
    <tr className="p-4 rounded odd:bg-gray-900 rounded">
      <td className="p-4 text-sm rounded-l">
        <div className="flex items-center">
          <span className="text-gray-300 mr-1 ">{getOrdinal(index + 1)}.</span>
          <span>{userProfileLink(userData?.username)}</span>
        </div>
      </td>
      <td className="p-4 text-sm">
        <div className="flex items-center justify-center">
          <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" /> {convertAmount(item.value)}
        </div>
      </td>
      <td className="p-4 text-sm rounded-r">
        <div className="flex items-center justify-end">
          <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" /> {convertAmount(prizes[index])}
        </div>
      </td>
    </tr>
  )
}

const userProfileLink = (user) => {
  if (user == "Hidden") return (
    <p className="flex items-center justify-center space-x-1">
      <ShieldCheckIcon className="w-4" />
      <span className="font-medium">Hidden</span>
    </p>
  )
  return (
    <Link className="flex items-center justify-center space-x-1" to={{ search: '&modal=user&name=' + user }}>
      <span className="text-white font-medium">{user}</span>
    </Link>
  )
}